import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { EventsService } from 'src/app/services/event/event.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { JurisdictionService } from 'src/app/services/geo/jurisdiction.service';
import { toBoolean } from 'src/app/services/codeUtils';

@Component({
    selector: 'app-signup-result',
    templateUrl: './signup-result.component.html',
    styleUrls: ['./signup-result.component.scss'],
})
export class SignupResultComponent implements OnInit {


    public wasSuccessful: boolean = true;
    public responsibleGamingNumber: string;
    public startupBoydRewardEnrollPopupEnabled: number;
    public pageToRedirect: string;

    constructor(
        protected config: ConfigService,
        protected userSessionService: UserSessionService,
        protected utils: UtilsService,
        private eventsService: EventsService,
        private lobbyService: LobbyService,
        private navigator: Navigator,
        public authenticationService: AuthenticationService,
        private boydRewardsService: BoydRewardsService,
        private jurisdiction: JurisdictionService
    ) { }

    ngOnInit(): void {
        this.responsibleGamingNumber = this.config.getConfig().RESPONSIBLE_GAMING_NUMBER ?? '1-800-522-4700';
        this.startupBoydRewardEnrollPopupEnabled = parseInt(this.config.getConfig().BOYD_REWARDS_ENROLL_START) ?? 0;
    }

    ionViewCanLeave() {
        // localStorage.setItem('MFA.signup', 'false');
    }

    closeSuccessModal = () => {
        setTimeout(() => {
            if(this.userSessionService.getMFAStatus() && this.userSessionService.getMFAStatus() == "true") this.doMFA() 
            else this.activateCustomer();
        }, 500);
    }

    protected openPage(page) {
        //setting it in the page state, to reffer later on callback
        this.pageToRedirect = page;
        setTimeout(() => {
            // should not be neccessary anymore, as we do mfa before, but better have it here anyway as backup
            if(this.userSessionService.getMFAStatus() && this.userSessionService.getMFAStatus() == "true") this.doMFA() 
            else this.activateCustomer();
            this.pageToRedirect = null;
        }, 500);
    }

    protected redirectUser(): void {
        this.eventsService.publish("event:login", {
            customer_id: this.userSessionService.getCustomerId(),
          });
          
        if(!this.pageToRedirect){
          this.eventsService.publish('action:changeTab', 'casino');
        } else {
            this.navigator.navigateTo(this.pageToRedirect, { multipleModals: true }, { previousPage: "SignupResult" });
        }
    }

    private activateCustomer = () => {
        localStorage.setItem('MFA.signup', 'false');
        this.userSessionService.refreshCustomer().subscribe((customer: CustomerModel) => {
            this.lobbyService.setCurrentLoginTime(customer.currentLoginTime);
            this.userSessionService.setUserStatus({
                customerId: customer.customerId,
                sessionToken: this.userSessionService.getSessionToken()
            })
        });


		const config = this.config.getConfig();
		const geoAfterLoginFlag: boolean = this.config.isFeatureON( config, 'FEATURE_GEOLOCATION_ENFORCED_ON_LOGIN', true);
        // Prompting user to signup for Momentum Rewards Loyalty Program just once after sucessful SignUp
        if (this.startupBoydRewardEnrollPopupEnabled) {
            this.boydRewardsService.checkConnectionToBoydCard().subscribe(res => {
                if (!res) {
                    this.navigator.navigateTo('EnrollBoydRewardsComponent', '', { connectBoydCardPath: true, callBackFn: () => { this.addGeo(); } })
                } else {
                    if (geoAfterLoginFlag) this.addGeo();
                }
            })
        } else {
            if (geoAfterLoginFlag) this.addGeo();
        }

        
        this.redirectUser();
        this.eventsService.publish("event:notifications:start");
    }

    private addGeo = () => {
        this.jurisdiction
            .debounceVerifyJurisdiction(() => { })
            .then((geoResp: GeoResponse) => {
                console.log('Signup Result geo check');
            })
            .catch((err) => {
                console.log("Signup Result: launch aborted.", err);
            });
    }

    public doMFA(): any {
        const isSMS_OR_EMAIL = this.config.getConfig().FEATURE_MFA_TYPE ?? 'SMS';
        const mfa_statuses = this.config.getConfig().FEATURE_MFA_STATUSES ?? 'ACTIVE, REAL_LOCKED, SELF_EXCLUDED_COOL_OFF, FUNDS_HELD';
        
        return this.userSessionService.refreshCustomer().subscribe((customer: CustomerModel) => {
            if (isSMS_OR_EMAIL == 'SMS') {
              this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: customer.customerId, callback: this.activateCustomer })
            } else {
              this.navigator.navigateTo("CodeLoginPage", { forceModal: true }, { customerId: customer.customerId, callback: this.activateCustomer })
            }
        });
      }

}
